module.exports = __webpack_public_path__ + "media/images/category_icons/events-00b11861aa9d25b3ee2676fbc1f42981.svg";